<template>
  <DesktopLayout :hide-side-panel="hideSidePanelAndHeader" :hide-header="hideSidePanelAndHeader">
    <Bubbles v-if="bubblesVisualisationActive" />
    <BubblesV2 v-if="bubblesV2VisualisationActive" />
    <XYBubbles v-if="xyBubblesVisualisationActive" />
    <MapWrapper v-if="mapVisualisationActive" />
    <NestedBubbles v-if="nestedBubblesVisualisationActive" />
    <Sunburst v-if="sunburstVisualisationActive" />
    <CustomVisualisation v-if="customVisualisationActive" />
  </DesktopLayout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import DesktopLayout from '@/components/public/DesktopLayout/DesktopLayout.vue'
import Bubbles from '@/components/public/Visualisations/Bubbles/Bubbles.vue'
import BubblesV2 from '@/components/public/Visualisations/BubblesV2/BubblesV2.vue'
import XYBubbles from '@/components/public/Visualisations/XYBubbles/XYBubbles.vue'
import MapWrapper from '@/components/public/Visualisations/TheMap/MapWrapper.vue'
import NestedBubbles from '@/components/public/Visualisations/NestedBubbles/NestedBubbles.vue'
import Sunburst from '@/components/public/Visualisations/Sunburst/Sunburst.vue'
import CustomVisualisation from '@/components/public/Visualisations/CustomVisualisation/CustomVisualisation.vue'
import { useFeaturesStore } from '@/store/common/features'
import { VIEW_VISUAL } from '@/constants'
import { VisualisationType } from '@/types'

const components = {
  DesktopLayout,
  Bubbles,
  XYBubbles,
  BubblesV2,
  MapWrapper,
  NestedBubbles,
  Sunburst,
  CustomVisualisation,
}

// eslint-disable-next-line no-use-before-define
@Component<VisualisationView>({
  components,
  watch: {
    appLoaded(appLoaded: Boolean) {
      if (appLoaded) {
        this.activeVisualisation.setLastActiveVisualisationType(this.visualisationType)
      }
    },
    visualisationType(visualisationType: VisualisationType) {
      if (this.appLoaded) {
        this.activeVisualisation.setLastActiveVisualisationType(visualisationType)
      }
    },
  },
})
export default class VisualisationView extends Vue {
  get activeVisualisation() {
    return this.$typedStore.activeVisualisation
  }

  get appLoaded() {
    return this.activeVisualisation.appLoaded
  }

  get useBubblesV2() {
    return useFeaturesStore().useBubblesV2
  }

  get visualisationType() {
    return this.activeVisualisation.visualisationType
  }

  get bubblesVisualisationActive() {
    return this.activeVisualisation.isBubbles && !this.useBubblesV2
  }

  get bubblesV2VisualisationActive() {
    return this.activeVisualisation.isBubbles && this.useBubblesV2
  }

  get mapVisualisationActive() {
    return this.activeVisualisation.isMap
  }

  get nestedBubblesVisualisationActive() {
    return this.activeVisualisation.isNestedBubbles
  }

  get sunburstVisualisationActive() {
    return this.activeVisualisation.isSunburst
  }

  get xyBubblesVisualisationActive() {
    return this.activeVisualisation.isXYBubbles
  }

  get customVisualisationActive() {
    return this.activeVisualisation.isCustom
  }

  get mainpanel() {
    return this.$typedStore.currentRoute.params.mainpanel
  }

  get hideSidePanelAndHeader() {
    if (this.mainpanel === VIEW_VISUAL && !this.useBubblesV2) {
      return true
    }
  }
}
</script>
